<template>
    <div>
        <!-- 新增/编辑线路对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="90%" :close-on-click-modal="false">
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-form size="small" :model="formData" :rules="rules" ref="formRef" label-width="100px">
                        <el-form-item label="线路ID" prop="routeID" v-if="isEdit">
                            <el-input v-model="formData.routeID" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="线路名称" prop="routeName">
                            <el-input v-model="formData.routeName" placeholder="请输入线路名称"></el-input>
                        </el-form-item>

                        <!-- 轨迹获取区域功能，仅在新增线路时显示 -->
                        <div v-if="!isEdit">
                            <el-divider>从车辆轨迹获取区域</el-divider>
                            <el-form-item label="选择车辆">
                                <el-select v-model="selectedVehicleId" placeholder="请选择车辆" clearable
                                    style="width: 100%;">
                                      <el-option
                    v-for="item in vehicles.data"
                    v-if="item.treeLevel == 5"
                    :key="item.nodeValue"
                    :label="item.name"
                    :value="item.nodeValue"
                  >
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary" size="mini" @click="getAreaFromTrajectory"
                                    :disabled="!selectedVehicleId">
                                    <i class="el-icon-map-location"></i> 获取轨迹区域列表
                                </el-button>
                            </el-form-item>
                        </div>

                        <!-- 区域列表 -->
                        <el-divider>线路区域列表</el-divider>
                        <div class="area-list-container" style="height: 400px;">
                            <AreaList ref="areaList" :map="dialogMap" :isEditModel="true" />
                        </div>

                    </el-form>
                </el-col>

                <!-- 右侧：地图 -->
                <el-col :span="14">
                    <div class="dialog-map-container">
                        <KingLongMap ref="dialogMap" mapId="route_dialog_map" @LoadCompleted="DialogMapLoadCompleted"
                            @DrawRectangleCompleted="onDialogDrawRectangleCompleted" />
                    </div>
                </el-col>
            </el-row>

            <div slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">取消线路编辑</el-button>
                <el-button type="primary" size="mini" @click="saveRoute" :loading="dialogLoading">
                    {{ isEdit ? '更新线路' : '保存线路' }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";
import AreaList from "./area_list.vue";
import { mapState } from "vuex";
import { queryAutoRouteAreaListByVehicle, saveAutoRouteInfo, queryAutoRouteAreaList } from "@/http/vehicle";
export default {
    name: 'RouteEdit',
    components: {
        KingLongMap,
        AreaList
    },
      computed: {
    ...mapState({
      vehicles: (state) => state.app.vehicles,
      
    }),
    size() {
      return this.$store.getters.size;
    },
  },
    data() {
        return {
            rules: {
                routeName: [
                    { required: true, message: '请输入线路名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '线路名称长度在 2 到 50 个字符', trigger: 'blur' }
                ]
            },
            dialogLoading: false,
            dialogTitle: '',
            isEdit: false,
            isEditModel: false,//编辑或者是新增            
            dialogVisible: false,
            dialogMap: null,
            formData: {
                routeID: 0,
                routeName: '',

            },

            // 新增：车辆列表和轨迹区域相关数据
            vehicleList: [
                { vehicleId: 'V001', vehicleName: '车辆1' },
                { vehicleId: 'V002', vehicleName: '车辆2' },
                { vehicleId: 'V003', vehicleName: '车辆3' },
                { vehicleId: 'V004', vehicleName: '车辆4' },
                { vehicleId: 'V005', vehicleName: '车辆5' }
            ],
            selectedVehicleId: '',
        }
    },
    methods: {
        edit(row) {
            this.isEdit = true;
            this.dialogTitle = '编辑线路';
            this.dialogVisible = true;
            this.formData = Object.assign({}, row);
            //设置区域列表
            queryAutoRouteAreaList({
                routeID: row.routeID,
            }).then(res => {

                if (res.code === 200) {
                    this.$refs.areaList.setAreaList(res.data.areaInfo.areaList || []);

                }
            });

        },
        // 新增：新增线路
        add() {
            this.isEdit = false;
            this.dialogTitle = '新增线路';
            this.dialogVisible = true;
            this.resetForm();
        },
        // 重置线路表单
        resetForm() {
            this.formData = {
                routeID: 0,
                routeName: ''
            };
            // 重置轨迹相关字段
            this.selectedVehicleId = '';

            this.$nextTick(() => {
                this.$refs.areaList.setAreaList([]);
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },
        // 从历史车辆行驶轨迹获取区域
        getAreaFromTrajectory() {
            if (!this.selectedVehicleId) {
                this.$message.error('请选择车辆');
                return;
            }

            this.dialogLoading = true;

            queryAutoRouteAreaListByVehicle({
                //    vehicleId: this.selectedVehicleId,
            }).then(res => {
                if (res.code === 200) {
                    this.$refs.areaList.setAreaList(res.data);

                } else {
                    this.$message.error(res.msg || '获取轨迹区域列表失败');
                }
                this.dialogLoading = false;
            }).catch(() => {
                this.$message.error('获取轨迹区域列表失败');
                this.dialogLoading = false;
            });


        },



        // 更新线路
        updateRoute(routeData) {
            // 模拟更新线路API调用
            setTimeout(() => {
                const index = this.routeList.findIndex(route => route.routeID === routeData.routeID);
                if (index !== -1) {
                    this.routeList[index] = {
                        ...this.routeList[index],
                        ...routeData,
                        updateTime: new Date().toLocaleString()
                    };
                }
                this.dialogVisible = false;
                this.$message.success('线路更新成功');
                this.dialogLoading = false;
            }, 1000);
        },

        // 保存线路
        saveRoute() {

            // 验证表单
            if (!this.$refs.formRef) return;
            this.dialogLoading = true;
            this.$refs.formRef.validate((valid) => {
                if (!valid) {
                    this.$message.error('请填写完整的线路信息');
                    this.dialogLoading = false;
                    return false;
                }
            });

            var areaList = this.$refs.areaList.getAreaList();

            //判断是否有区域
            if (areaList.length === 0) {
                this.$message.error('请添加至少一个区域');
                this.dialogLoading = false;
                return false;
            }

            saveAutoRouteInfo({
                routeID: this.formData.routeID,
                routeName: this.formData.routeName,
                areaList: areaList
            }).then(res => {

                if (res.code === 200) {
                    this.$emit('saveSuccess');
                    this.$message.success('线路保存成功');
                    this.dialogVisible = false;

                } else {
                    this.$message.error(res.msg || '线路保存失败');
                }
                this.dialogLoading = false;
            }).catch(() => {
                this.$message.error('线路保存失败');
                this.dialogLoading = false;
            });

            return;


        },
       
        // 对话框绘制矩形完成
        onDialogDrawRectangleCompleted(rectangle) {
            // this.areaFormData.topLeft = rectangle.getBounds().getNorthWest();
            // this.areaFormData.bottomRight = rectangle.getBounds().getSouthEast();
        },
        DialogMapLoadCompleted() {
            this.dialogMap = this.$refs.dialogMap;

        },
    }
}
</script>
<style scoped>
/* 对话框地图容器样式 */
.dialog-map-container {
    width: 100%;
    height: 500px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}
</style>
